<template>
  <router-view transition="fab-transition"></router-view>
</template>
<script>
export default {
  name: 'KeepAliveRouteWrapper',
}
</script>

<style></style>
